export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10269.ad97bc01.jpg";